module.exports = __webpack_public_path__ + "img/coinbase_wallet.b818daee.svg";